import { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Modal, Upload, notification } from 'antd';
import PropTypes from 'prop-types';
import { getBase64 } from '../../utils/functions';

const UploadImage = ({
  UploadImagelimit = 10,
  handleChange,
  fileList = [],
  className,
  placeholder = 'Image',
  multiple = true,
  handleRemove,
  errorMessage,
  maxFileSize = 1,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const handleCancel = () => setPreviewOpen(false);

  const validateFile = file => {
    const isValidSize = file.size / 1024 / 1024 < maxFileSize;
    if (!isValidSize) {
      notification.error({
        message: 'File Size Error',
        description: `File size should be less than ${maxFileSize}MB`,
      });
      return false;
    }
    return true;
  };

  const handleChangeWithErrorRecovery = info => {
    const { file, fileList: newFileList } = info;

    if (file.status === 'error') {
      const filteredList = newFileList.filter(f => f.uid !== file.uid);
      notification.error({
        message: 'Upload Failed',
        description: 'Failed to upload file. Please try again.',
      });
      handleChange?.({ ...info, fileList: filteredList });
      return false;
    }

    handleChange?.(info);
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }}>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload {placeholder}</div>
    </button>
  );

  return (
    <>
      <Upload
        className={className}
        multiple={multiple}
        listType="picture-card"
        customRequest={({ onSuccess }) => onSuccess('ok')}
        fileList={fileList}
        onPreview={async file => {
          if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
          }
          setPreviewImage(file.url || file.preview);
          setPreviewOpen(true);
          setPreviewTitle(file.name || file.url?.substring(file.url.lastIndexOf('/') + 1));
        }}
        onChange={handleChangeWithErrorRecovery}
        accept="image/*"
        onRemove={handleRemove}
        beforeUpload={file => {
          if (!validateFile(file)) return Upload.LIST_IGNORE;
          return true;
        }}
      >
        {fileList.length >= UploadImagelimit ? null : uploadButton}
      </Upload>
      {errorMessage && <div style={{ color: '#DC3545' }}>{errorMessage}</div>}
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        zIndex={1050}
      >
        <img alt="preview" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </>
  );
};

UploadImage.propTypes = {
  handleChange: PropTypes.func,
  handleRemove: PropTypes.func,
  UploadImagelimit: PropTypes.number,
  multiple: PropTypes.bool,
  fileList: PropTypes.array,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  maxFileSize: PropTypes.number,
};

export default UploadImage;
